//@ts-nocheck
import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

const ProducerSelect = ({ producers, selectedProducer, onChange }) => {
  return (
    <Row className="mb-4">
      <Col md={6}>
        <Form.Group>
          <Form.Label>
            <strong>Wybierz producenta *</strong>
          </Form.Label>
          <Form.Select
            value={selectedProducer}
            onChange={(e) => onChange(e.target.value)}
            size="lg"
          >
            <option value="">-- Wybierz producenta --</option>
            {producers.map((producer) => (
              <option key={producer._id} value={producer.name}>
                {producer.name}
              </option>
            ))}
          </Form.Select>
          <Form.Text className="text-muted">
            Po wybraniu producenta zostanie wyświetlona lista dostępnych
            produktów
          </Form.Text>
        </Form.Group>
      </Col>
    </Row>
  );
};

export default ProducerSelect;
